/* PNW Mini Cart — stable: catch product adds via submit, click anchors, programmatic submit, fetch & XHR; open drawer + update badge */
/* NOTE: Form intercept code is now inlined in theme.liquid to reduce render-blocking time */
(function(){
  const IDS = { root: 'pnwMiniCart', body: 'pnwmcBody' };
  const SEL = { openers: '[data-open-mini-cart], .header-actions__action--cart' };

  const $ = (s,sc)=> (sc||document).querySelector(s);
  const $$ = (s,sc)=> (sc||document).querySelectorAll(s);
  const root = ()=> $('#'+IDS.root);
  const body = ()=> $('#'+IDS.body);

  function lock(){ document.documentElement.classList.add('pnw-no-scroll'); }
  function unlock(){ document.documentElement.classList.remove('pnw-no-scroll'); }
  function openMC(){ 
    const r=root(); 
    if (!r) return;
    
    // Ensure visibility is set
    r.style.visibility = '';
    
    // Get panel
    const panel = r.querySelector('.pnwmc__panel');
    if (!panel) return;
    
    // Set aria-hidden to false FIRST
    r.setAttribute('aria-hidden','false'); 
    
    // Remove inline transform and transition, then explicitly set to visible
    panel.style.removeProperty('transform');
    panel.style.removeProperty('transition');
    
    // Force a reflow
    void panel.offsetHeight;
    
    // Explicitly set transform to visible position with transition
    panel.style.transition = 'transform .25s ease, box-shadow .25s ease';
    panel.style.transform = 'translateX(0)';
    
    lock(); 
  }
  function closeMC(){ 
    const r=root(); 
    if (!r) return;
    
    // Set aria-hidden to true FIRST
    r.setAttribute('aria-hidden','true'); 
    
    // Get panel and explicitly set transform to hidden position
    const panel = r.querySelector('.pnwmc__panel');
    if (panel) {
      // Explicitly set transform to hidden with transition
      panel.style.transition = 'transform .25s ease, box-shadow .25s ease';
      panel.style.transform = 'translateX(100%)';
      
      // After transition completes, remove inline transform to let CSS handle it
      setTimeout(() => {
        if (r.getAttribute('aria-hidden') === 'true') {
          // Only remove if still closed
          panel.style.removeProperty('transform');
        }
      }, 250);
    }
    
    unlock(); 
  }

  // Treat ONLY product add forms as "add to cart": must contain variant input
  function isProductAddForm(form){
    if (!form) return false;
    if (!form.querySelector('input[name="id"]')) return false;
    const action = (form.getAttribute('action')||'/cart/add').split('?')[0];
    return /^\/cart(\/add)?$/i.test(action);
  }

  // ---------- Redirect suppressor (block /cart navigation briefly after add)
  let suppressUntil = 0;
  function suppressCartRedirect(ms=2500){ suppressUntil = Date.now() + ms; }

  (function hookLocation(){
    try{
      const _assign = window.location.assign.bind(window.location);
      const _replace = window.location.replace.bind(window.location);
      Object.defineProperty(window.location,'href',{
        set(v){
          if (Date.now() < suppressUntil && /\/cart(\?|$)/.test(String(v||''))) { return; }
          _assign(String(v||''));
        }
      });
      window.location.assign = function(url){
        if (Date.now() < suppressUntil && /\/cart(\?|$)/.test(String(url||''))) { return; }
        return _assign(url);
      };
      window.location.replace = function(url){
        if (Date.now() < suppressUntil && /\/cart(\?|$)/.test(String(url||''))) { return; }
        return _replace(url);
      };
    }catch(_){}
  })();

  async function fetchCart(){
    const res = await fetch('/cart.js', { cache:'no-store', credentials:'same-origin' });
    if (!res.ok) throw new Error('cart.js '+res.status);
    return res.json();
  }

  function renderCart(cart){
    const target = body(); if (!target) return;
    if (!cart || !cart.items || !cart.items.length){
      target.innerHTML = `<div class="pnwmc__empty">Your cart is empty.</div>`;
      return;
    }
    
    // Simple money formatter (fallback if Shopify.formatMoney doesn't exist)
    function formatMoney(cents){
      try {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents);
        }
      } catch(e) {}
      // Fallback: convert cents to dollars
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars;
    }
    
    const lines = cart.items.map((li, idx)=>{
      const v = (li.variant_title && li.variant_title !== 'Default Title') ? `<div class="pnwmc__meta">${li.variant_title}</div>` : '';
      const img = li.image || '';
      return `
        <li class="pnwmc__line">
          <a class="pnwmc__thumb" href="${li.url}">
            <img src="${img}" alt="${(li.product_title||'').replace(/"/g,'&quot;')}" loading="lazy">
          </a>
          <div class="pnwmc__details">
            <a class="pnwmc__titlelink" href="${li.url}">${li.product_title}</a>
            ${v}
            <div class="pnwmc__qty-control">
              <button class="pnwmc__qty-btn" data-line-index="${idx + 1}" data-action="decrease" aria-label="Decrease quantity">−</button>
              <span class="pnwmc__qty-display">${li.quantity}</span>
              <button class="pnwmc__qty-btn" data-line-index="${idx + 1}" data-action="increase" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <div class="pnwmc__right">
            <div class="pnwmc__price">${formatMoney(li.final_line_price)}</div>
            <button class="pnwmc__remove" data-line-index="${idx + 1}" aria-label="Remove ${(li.product_title||'').replace(/"/g,'&quot;')}">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            </button>
          </div>
        </li>`;
    }).join('');
    target.innerHTML = `
      <ul class="pnwmc__list">${lines}</ul>
      <div class="pnwmc__subtotal"><span>Subtotal</span><span>${formatMoney(cart.total_price)}</span></div>
      <p class="pnwmc__fine">Taxes & shipping calculated at checkout.</p>
    `;
  }

  // ⭐ CRITICAL: These functions MUST be defined HERE (after renderCart, before event listeners)
  
  // Handle remove item from cart
  async function removeItem(lineIndex){
    try{
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: 0 })
      });
      if (!res.ok) throw new Error('Remove failed');
      await openAndRender();
    }catch(err){ console.error('mini-cart remove error', err); }
  }

  // Handle quantity changes
  async function changeQuantity(lineIndex, newQty){
    try{
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: newQty })
      });
      if (!res.ok) throw new Error('Quantity change failed');
      await openAndRender();
    }catch(err){ console.error('mini-cart quantity error', err); }
  }

  async function updateBubble(){
    try{
      const res = await fetch('/cart.js', {cache:'no-store'});
      if (!res.ok) {
        console.warn('[PNW Mini Cart] Failed to fetch cart for bubble update:', res.status);
        return;
      }
      const cart = await res.json();
      const n = cart.item_count||0;
      
      // Function to update a single element
      function updateElement(el, isTabCount = false, isHeaderCount = false) {
        if (isHeaderCount) {
          // For header cart count - just update text content
          el.textContent = n;
        } else if (isTabCount) {
          el.textContent = n;
        } else {
          el.innerHTML = `<span aria-hidden="true">${n}</span><span class="sr-only">Cart items: ${n}</span>`;
        }
        if (n === 0) {
          el.classList.add('is-empty');
        } else {
          el.classList.remove('is-empty');
        }
      }
      
      // Update header cart count (YOUR ACTUAL ELEMENT!)
      const headerCartCounts = document.querySelectorAll('.pnw-cart__count, .pnw2-cart-count');
      headerCartCounts.forEach(el=>{
        updateElement(el, false, true);
      });
      
      // Update ALL elements with [data-cart-count] attribute (legacy support)
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(el=>{
        updateElement(el);
      });
      
      // Also update cart-count-bubble elements (backup)
      const bubbleElements = document.querySelectorAll('.cart-count-bubble');
      bubbleElements.forEach(el=>{
        if (!el.hasAttribute('data-cart-count')) {
          updateElement(el);
        }
      });
      
      // Update side tab count
      const tabCountElements = document.querySelectorAll('[data-tab-count]');
      tabCountElements.forEach(el=>{
        updateElement(el, true);
      });
      
      // Also update the #cart-icon-bubble container's aria-label for screen readers
      const iconBubble = document.getElementById('cart-icon-bubble');
      if (iconBubble) {
        iconBubble.setAttribute('aria-label', `Shopping cart with ${n} item${n !== 1 ? 's' : ''}`);
      }
      
      // AGGRESSIVE: Re-update after a short delay to override any competing scripts
      requestAnimationFrame(() => {
        headerCartCounts.forEach(el => updateElement(el, false, true));
        cartCountElements.forEach(el => updateElement(el));
        bubbleElements.forEach(el => {
          if (!el.hasAttribute('data-cart-count')) updateElement(el);
        });
        tabCountElements.forEach(el => updateElement(el, true));
      });
      
      // EXTRA AGGRESSIVE: One more update after 100ms
      setTimeout(() => {
        const headerCounts = document.querySelectorAll('.pnw-cart__count, .pnw2-cart-count');
        headerCounts.forEach(el => updateElement(el, false, true));
        const elements = document.querySelectorAll('[data-cart-count]');
        elements.forEach(el => updateElement(el));
        const tabs = document.querySelectorAll('[data-tab-count]');
        tabs.forEach(el => updateElement(el, true));
      }, 100);
    }catch(err){
      console.error('[PNW] ❌ Error updating cart count:', err);
    }
  }

  async function openAndRender(){
    try{
      const cart = await fetchCart();
      renderCart(cart);
      // Update bubble count first
      await updateBubble();
      // Then open the cart
      openMC();
    }catch(e){ 
      console.error('mini-cart open/render error', e);
      // Even if there's an error, try to open the cart
      openMC();
    }
  }

  // Initialize cart count on page load
  async function initCartCount(){
    await updateBubble();
  }

  // Run initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartCount);
  } else {
    // DOM already loaded
    initCartCount();
  }

  /* ---------- OPEN FROM HEADER (no navigation) ---------- */
  document.addEventListener('click', async (e)=>{
    const opener = e.target.closest(SEL.openers);
    if (opener){ 
      e.preventDefault(); 
      e.stopPropagation(); 
      e.stopImmediatePropagation(); 
      openAndRender(); 
      return; 
    }
    
    const r = root();
    if (!r) return;
    
    // Check for close button or overlay click
    const closeBtn = e.target.closest('[data-mc-close]');
    const overlay = r.querySelector('.pnwmc__overlay');
    
    if (closeBtn || e.target === overlay){
      e.preventDefault(); 
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeMC();
      return;
    }
  }, true);

  // Escape key to close
  document.addEventListener('keydown', (e)=>{ 
    if (e.key === 'Escape' || e.keyCode === 27) {
      const r = root();
      if (r && r.getAttribute('aria-hidden') === 'false') {
        e.preventDefault();
        e.stopPropagation();
        closeMC();
      }
    }
  }, true);

  // Explicit tab click handler (bulletproof)
  document.addEventListener('click', (e)=>{
    if (e.target.matches('.pnwmc__tab, .pnwmc__tab *')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openAndRender();
      return false;
    }
  }, true);

  // Handle remove and quantity button clicks (combined to avoid conflicts)
  document.addEventListener('click', async (e)=>{
    // Check for remove button first
    const removeBtn = e.target.closest('.pnwmc__remove');
    if (removeBtn){
      e.preventDefault();
      e.stopPropagation();
      const lineIndex = parseInt(removeBtn.getAttribute('data-line-index'), 10);
      if (lineIndex) removeItem(lineIndex);
      return;
    }
    
    // Then check for quantity buttons
    const qtyBtn = e.target.closest('.pnwmc__qty-btn');
    if (qtyBtn){
      e.preventDefault();
      e.stopPropagation();
      const lineIndex = parseInt(qtyBtn.getAttribute('data-line-index'), 10);
      const action = qtyBtn.getAttribute('data-action');
      
      if (!lineIndex) return;
      
      // Get current quantity from display
      const qtyDisplay = qtyBtn.parentElement.querySelector('.pnwmc__qty-display');
      const currentQty = parseInt(qtyDisplay.textContent, 10) || 1;
      
      let newQty = currentQty;
      if (action === 'increase') {
        newQty = currentQty + 1;
      } else if (action === 'decrease') {
        newQty = Math.max(0, currentQty - 1);
      }
      
      if (newQty === 0) {
        removeItem(lineIndex);
      } else {
        changeQuantity(lineIndex, newQty);
      }
      return;
    }
  }, true);

  /* ---------- PRODUCT ADDS — programmatic form.submit() ---------- */
  (function hookNativeSubmit(){
    const nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function(){
      try{
        if (isProductAddForm(this)){
          (async ()=>{
            try{
              await fetch('/cart/add.js', { method:'POST', body:new FormData(this) });
              suppressCartRedirect();
              openAndRender();
            }catch(err){ console.error('mini-cart programmatic add error', err); }
          })();
          return;
        }
      }catch(_){}
      return nativeSubmit.call(this);
    };
  })();

  /* ---------- PRODUCT ADDS — click on submit buttons / anchor-adds ---------- */
  document.addEventListener('click', (e)=>{
    const btn = e.target.closest('button[type="submit"], [type="submit"], button[name="add"]');
    const formFromBtn = btn ? btn.closest('form') : null;

    const a = e.target.closest('a[href^="/cart"]');
    const formFromAnchor = a ? (a.closest('form')||null) : null;

    const form = formFromBtn || formFromAnchor;
    if (!isProductAddForm(form)) return;

    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

    (async ()=>{
      try{
        const fd = new FormData(form);
        if (a){
          try{
            const u = new URL(a.getAttribute('href'), location.origin);
            if (u.searchParams.has('id')) fd.set('id', u.searchParams.get('id'));
            if (u.searchParams.has('quantity')) fd.set('quantity', u.searchParams.get('quantity'));
          }catch(_){}
        }
        const res = await fetch('/cart/add.js', { method:'POST', body: fd });
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(errorText);
        }
        // Clone and consume to wait for body to settle (some themes read it)
        // This is done via clone to avoid locking the original stream for the CLI proxy
        try {
          if (res.clone) {
            const cloned = res.clone();
            await cloned.text();
          }
        } catch(_) {
          // Ignore clone errors - response may have already been consumed
        }
        suppressCartRedirect();
        openAndRender();
      }catch(err){ console.error('mini-cart click add error', err); }
    })();
  }, true);

  /* ---------- PRODUCT ADDS — fetch & XHR from other scripts ---------- */
  const _fetch = window.fetch;
  window.fetch = async function(input, init){
    let url = '', method = (init && init.method) || (input && input.method) || 'GET';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch(_){}
    const isAdd = method.toUpperCase() === 'POST' && (url.includes('/cart/add.js') || url.endsWith('/cart/add.js'));
    const res = await _fetch.apply(this, arguments);
    if (isAdd && res && res.ok){
      // Clone and consume to wait for body to settle (some themes read it)
      // This is done via clone to avoid locking the original stream for the CLI proxy
      try {
        if (res.clone) {
          const cloned = res.clone();
          await cloned.text();
        }
      } catch(_) {
        // Ignore clone errors - response may have already been consumed
      }
      suppressCartRedirect();
      openAndRender();
    }
    return res;
  };

  // XHR hook
  (function hookXHR(){
    if (!window.XMLHttpRequest) return;
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      this._pnwAdd = method && method.toUpperCase() === 'POST' && /\/cart\/add\.js($|\?)/.test(String(url||''));
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(body){
      if (this._pnwAdd){
        this.addEventListener('load', function(){
          try{
            if (this.status >= 200 && this.status < 300){
              suppressCartRedirect();
              openAndRender();
            }
          }catch(_){}
        });
      }
      return _send.apply(this, arguments);
    };
  })();

  // Refresh cart without changing open/close state
  // ONLY call this when cart is already open to prevent flash
  async function refreshCart() {
    const r = root();
    const wasOpen = r && r.getAttribute('aria-hidden') === 'false';
    
    // CRITICAL: If cart is closed, do NOT touch the cart DOM at all - just update bubble
    if (!wasOpen) {
      await updateBubble();
      return;
    }
    
    // Only update content if cart is actually visible/open
    try {
      const cart = await fetchCart();
      
      // Save current scroll position to restore after update
      const bodyEl = body();
      const scrollPos = bodyEl ? bodyEl.scrollTop : 0;
      
      // Update content directly without any transitions
      renderCart(cart);
      await updateBubble();
      
      // Restore scroll position
      if (bodyEl && scrollPos > 0) {
        bodyEl.scrollTop = scrollPos;
      }
      
      // Double-check state is still preserved
      const currentlyOpen = r && r.getAttribute('aria-hidden') === 'false';
      if (currentlyOpen !== wasOpen && wasOpen) {
        // State was accidentally changed - restore immediately
        r.setAttribute('aria-hidden', 'false');
        lock();
      }
    } catch(err) {
      console.error('Cart refresh error:', err);
    }
  }

  // Expose updateBubble for external use
  async function updateBubblePublic() {
    await updateBubble();
  }

  // Debug helpers
  window.PNWMiniCart = { 
    open: openAndRender, 
    close: closeMC, 
    refresh: refreshCart,
    updateBubble: updateBubblePublic,
    openAndRender: openAndRender
  };
})();